/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Schema_Title6Inputs */

const en_svc_programmatic_seo_schema_title6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema markup`)
};

const ar_svc_programmatic_seo_schema_title6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترميز Schema`)
};

const bn_svc_programmatic_seo_schema_title6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema মার্কআপ`)
};

const de_svc_programmatic_seo_schema_title6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema-Markup`)
};

const es_svc_programmatic_seo_schema_title6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcado Schema`)
};

const fr_svc_programmatic_seo_schema_title6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balisage Schema`)
};

const pt_svc_programmatic_seo_schema_title6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcação Schema`)
};

const zh_svc_programmatic_seo_schema_title6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema 标记`)
};

const tr_svc_programmatic_seo_schema_title6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema işaretleme`)
};

const ru_svc_programmatic_seo_schema_title6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema-разметка`)
};

const pl_svc_programmatic_seo_schema_title6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znaczniki Schema`)
};

/**
* | output |
* | --- |
* | "Schema markup" |
*
* @param {Svc_Programmatic_Seo_Schema_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_schema_title6 = /** @type {((inputs?: Svc_Programmatic_Seo_Schema_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Schema_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_schema_title6(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_schema_title6(inputs)
	if (locale === "de") return de_svc_programmatic_seo_schema_title6(inputs)
	if (locale === "es") return es_svc_programmatic_seo_schema_title6(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_schema_title6(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_schema_title6(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_schema_title6(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_schema_title6(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_schema_title6(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_schema_title6(inputs)
	return en_svc_programmatic_seo_schema_title6(inputs)
});
export { svc_programmatic_seo_schema_title6 as "svc_programmatic-seo_SCHEMA_title" }